import * as dtos from "@/models/dtos";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox2.vue";
import InputText from "@/features/shared/components/form/InputText2.vue";
import InputTextWithHelpLink from "@/features/shared/components/form/InputTextWithHelpLink.vue";
import InputFile from "@/features/shared/components/form/InputFile.vue";
import InputTextarea from "@/features/shared/components/form/InputTextarea.vue";
import InputCheckboxGroup from "@/features/shared/components/form/InputCheckboxGroup2.vue";
import InputPeriodCheckboxGroup from "@/features/shared/components/form/InputPeriodCheckboxGroup.vue";
import InputRadio from "@/features/shared/components/form/InputRadio.vue";
import InputRadioGroup from "@/features/shared/components/form/InputRadioGroup.vue";
import InputPeriodCheckbox from "@/features/shared/components/form/InputPeriodCheckbox.vue";
import { Profile } from "@/models/Profile";
import { MainContainer } from "@/models/MainContainer";
import { FormBuilder2 } from "./FormBuilder2";
import { ContainerUser } from "./ContainerUser";
import { PositionTemplateAsset } from "./PositionTemplateFolder";
export class FormTemplate {
  someId = 1000;
  item: FormBuilder2;
  container: dtos.ContainerResponse;
  constructor(container: dtos.ContainerResponse, formbuilder: FormBuilder2) {
    this.container = container;
    this.item = formbuilder;
  }
  addValidation(property: dtos.DynamicProperty, name: string, data: any) {
    const validator = new dtos.PropertyValidator(name, data);
    if (property?.validators) property.validators.push(validator);
  }
  addInputStandard() {
    this.addInputProfile();
  }
  addTextArea(): dtos.PropertyItem {
    const text = "Stor textruta";
    const element = this.createInputTextarea(
      text,
      "textarea_" + this.createFormKey(),
      text
    );

    this.item.addTextArea(element.item);
    return element;
  }
  checkIfPropertyIsAdded(key: string): boolean {
    const property = this.item.Items.find((x) => x.item.key === key);

    return property ? true : false;
  }
  addInputViaCustomTemplate(template: dtos.PositionTemplateRequest) {
    const allPropertiesInCorrectOrder = template.metadata.properties.sort(
      (a, b) => a.order - b.order
    );
    allPropertiesInCorrectOrder.forEach((x) => {
      let property = null as any;

      switch (x.key) {
        case "form_firstname":
          property = this.addInputFirstname(x.placeholder, x.label);
          break;
        case "form_surname":
          property = this.addInputLastname(x.placeholder, x.label);
          break;
        case "form_ssn":
          property = this.addInputSSN(x.placeholder, x.label);
          break;
        case "form_address":
          property = this.addInputAddress(x.placeholder, x.label);
          break;
        case "form_zipcode":
          property = this.addInputZipCode(x.placeholder, x.label);
          break;
        case "form_city":
          property = this.addInputCity(x.placeholder, x.label);
          break;
        case "form_email":
          property = this.addInputEmail(x.placeholder, x.label);
          break;
        case "form_mobilePhone":
          property = this.addHomePhone(x.placeholder, x.label);
          break;
        case "form_additional":
          property = this.addAdditionalInfo(x);
          break;
        case "form_file":
          property = this.addFileupload(x.label);
          break;
        case "form_referer":
          property = this.addTemplateCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "form_agreement":
          property = this.addAggrementCheckboxGroup();
          break;
        case "form_linkedInUrl":
          property = this.addLinkToLinkedIn(x);
          break;
        case "summerpositionchoicesform":
          property = this.addSummerPositionChoicesCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "summerpositionperiodsform":
          property = this.addSummerPositionPeriodsCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "summerperiodsform":
          property = this.addSummerPeriodsCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "driverlicenseform":
          property = this.addDriverLicenseCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "licensetodriveform":
          property = this.addLicenseToDriveCheckboxGroup(
            x,
            x.data.keys.map((key: string) =>
              allPropertiesInCorrectOrder?.find((x) => x.key === key)
            )
          );
          break;
        case "requirementsform": {
          let propertiesFromKeys = [] as dtos.DynamicProperty[];
          x.data.keys.forEach((key: string) => {
            const property = allPropertiesInCorrectOrder?.find(
              (x) => x.key === key
            );
            if (property) {
              if (!propertiesFromKeys) propertiesFromKeys = [];
              propertiesFromKeys.push(property);
            }
          });
          property = this.addRequirementCheckboxGroupFromTemplate(
            propertiesFromKeys,
            x?.label || ""
          );
          break;
        }
        default:
          if (x.key.includes("textarea_")) {
            property = this.addAdditionalInfo(x);
            break;
          }
          if (x.type === "radioGroup" && x.key.includes("radio-group_")) {
            let propertiesFromKeys = [] as dtos.DynamicProperty[];
            x.data.keys.forEach((key: string) => {
              const property = allPropertiesInCorrectOrder?.find(
                (x) => x.key === key
              );
              if (property) {
                if (!propertiesFromKeys) propertiesFromKeys = [];
                propertiesFromKeys.push(property);
              }
            });
            property = this.addRadioGroupFromTemplate(
              propertiesFromKeys,
              x?.label || ""
            );
            break;
          }
          if (x.type === "group" && x.key.includes("customform_")) {
            let propertiesFromKeys = [] as dtos.DynamicProperty[];
            x.data.keys.forEach((key: string) => {
              const property = allPropertiesInCorrectOrder?.find(
                (x) => x.key === key
              );
              if (property) {
                if (!propertiesFromKeys) propertiesFromKeys = [];
                propertiesFromKeys.push(property);
              }
            });
            property = this.addCustomCheckboxGroupFromTemplate(
              propertiesFromKeys,
              x?.label || ""
            );
            break;
          }
          break;
      }

      if (x?.validators && x.validators.length > 0 && property) {
        x.validators.forEach((y) => {
          this.addValidation(property, y?.name, y?.data);
        });
      }
    });
  }

  addInputProfile() {
    const minLengthProperty = new dtos.PropertyValidator("minLength", 1);

    let property;

    if (!this.checkIfPropertyIsAdded("form_firstname")) {
      property = this.addInputFirstname();
      if (property?.validators) property.validators.push(minLengthProperty);
    }
    if (!this.checkIfPropertyIsAdded("form_surname")) {
      property = this.addInputLastname();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_ssn")) {
      property = this.addInputSSN();
      if (property?.validators) property.validators.push(minLengthProperty);
      const minYear = new dtos.PropertyValidator("ssnValidSwe", "");
      if (property?.validators) property.validators.push(minYear);
    }

    if (!this.checkIfPropertyIsAdded("form_address")) {
      property = this.addInputAddress();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_zipcode")) {
      property = this.addInputZipCode();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_city")) {
      property = this.addInputCity();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_mobilePhone")) {
      property = this.addHomePhone();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_email")) {
      property = this.addInputEmail();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_additional")) {
      property = this.addAdditionalInfo();
    }

    if (!this.checkIfPropertyIsAdded("form_file")) {
      property = this.addFileupload();
    }

    if (!this.checkIfPropertyIsAdded("form_referer")) {
      this.addTemplateCheckboxGroup();
    }

    if (!this.checkIfPropertyIsAdded("form_aggrement")) {
      this.addAggrementCheckboxGroup();
    }
  }
  addAddresTemplate() {
    const minLengthProperty = new dtos.PropertyValidator("minLength", 1);

    let property;

    if (!this.checkIfPropertyIsAdded("form_address")) {
      property = this.addInputAddress();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_zipcode")) {
      property = this.addInputZipCode();
      if (property?.validators) property.validators.push(minLengthProperty);
    }

    if (!this.checkIfPropertyIsAdded("form_city")) {
      property = this.addInputCity();
      if (property?.validators) property.validators.push(minLengthProperty);
    }
  }
  addInputFirstname(
    placeholder?: string,
    label?: string
  ): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_firstname")) return;

    const input = this.createInput(
      placeholder || "Förnamn",
      "text",
      "form_firstname",
      label || "Förnamn"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addInputLastname(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_surname")) return;

    const input = this.createInput(
      placeholder || "Efternamn",
      "text",
      "form_surname",
      label || "Efternamn"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addFileupload(label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_file")) return;

    const input = this.createInputFile(
      label || "CV och personligt brev",
      "file",
      "form_file"
    );
    this.item.addInputFile(input.item);
    return input.item;
  }
  addAdditionalInfo(property?: dtos.DynamicProperty): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded(property?.key || "form_additional")) return;

    const input = this.createInputTextarea(
      property?.placeholder || "Övriga upplysningar",
      property?.key || "form_additional",
      property?.label || "Övriga upplysningar"
    );
    this.item.addTextArea(input.item);
    return input.item;
  }
  addInputAddress(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_address")) return;

    const input = this.createInput(
      placeholder || "Adress",
      "text",
      "form_address",
      label || "Adress"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addHomePhone(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_homePhone")) return;

    const input = this.createInput(
      placeholder || "Telefonnummer",
      "text",
      "form_homePhone",
      label || "Telefonnummer"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addMobilPhone(): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_mobilePhone")) return;

    const input = this.createInput("Mobilnummer", "text", "form_mobilePhone");
    this.item.addInput(input.item);
    return input.item;
  }
  addInputZipCode(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_zipcode")) return;

    const input = this.createInput(
      placeholder || "Postnummer",
      "text",
      "form_zipcode",
      label || "Postnummer"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addInputSSN(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_ssn")) return;

    const input = this.createInput(
      placeholder || "Personnummer",
      "text",
      "form_ssn",
      label || "Personnummer"
    );
    this.item.addInput(input.item);
    return input.item;
  }
  addInputCity(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_city")) return;

    const input = this.createInput(
      placeholder || "Postort",
      "text",
      "form_city",
      label || "Postort"
    );
    this.item.addInput(input.item);
    return input.item;
  }

  addInputEmail(placeholder?: string, label?: string): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_email")) return;

    const input = this.createInput(
      placeholder || "E-post",
      "email",
      "form_email",
      label || "E-post"
    );
    const validEmailValidator = new dtos.PropertyValidator("validEmail", "");
    if (input?.item?.validators)
      input.item.validators.push(validEmailValidator);
    this.item.addInput(input.item);
    return input.item;
  }
  addLinkToLinkedIn(property?: dtos.DynamicProperty): dtos.DynamicProperty {
    if (this.checkIfPropertyIsAdded("form_linkedInUrl")) return;

    const input = this.createTextInputWithHelpLink(
      property?.label || "Länk till din LinkedIn-profil",
      property?.key || "textWithHelpLink",
      property?.key || "form_linkedInUrl",
      property?.placeholder ||
        "https://www.linkedin.com/help/linkedin/suggested/49315/finding-your-linkedin-public-profile-url"
    );
    this.item.addInputWithHelpLink(input.item);
    return input.item;
  }

  addInput() {
    const input = {
      id: InputText,
      item: this.createProperty("Placeholder", "text"),
    };

    input.item.key = `form_text_${crypto.randomUUID()}`;
    this.item.addInput(input.item);
    // emit("add", item);
  }
  addCheckbox(): dtos.DynamicProperty {
    const item = {
      id: InputCheckbox,
      item: this.createProperty("Placeholder", "checkbox"),
    };
    // emit("add", item);
    return item.item;
  }
  addRadioButton(): dtos.DynamicProperty {
    const item = {
      id: InputRadio,
      item: this.createProperty("", "radio"),
    };
    return item.item;
  }
  addPeriodCheckbox(): dtos.DynamicProperty {
    const item = {
      id: InputPeriodCheckbox,
      item: this.createProperty("", "periodCheckbox"),
    };
    // emit("add", item);
    return item.item;
  }
  addAggrementCheckboxGroup() {
    if (this.checkIfPropertyIsAdded("form_agreement")) return;
    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty("Villkor", "group"),
    };
    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `form_agreement`;

    const checkbox = this.addCheckbox();

    checkbox.label = `Härmed godkänner jag att mina personuppgifter registreras och behandlas för rekrytering. Lämnade uppgifter kommer att vara tillgängliga för HR och rekryterande personer inom organisationen i enlighet med GDPR. <a id="term01" ref="term01" class=" text-blue-1 underline cursor-pointer sm:w-auto">Här kan du läsa avtalet i sin helhet.</a>`;
    checkbox.placeholder = checkbox.label;
    checkbox.isHtml = true;
    const aggrementApprovValidator = new dtos.PropertyValidator(
      "approved",
      true
    );
    if (checkbox?.validators)
      checkbox.validators.push(aggrementApprovValidator);

    this.item.addMetadata(checkbox);
    group.item.data.keys.push(checkbox.key);

    this.item.addMetadata(group.item);

    const checkbox2 = this.addCheckbox();

    const companyName =
      this.container?.id === 382
        ? "Multi X Sweden AB"
        : "Applicationportal Sweden AB";

    checkbox2.label = `Jag har tagit del av ${companyName}s information om personuppgiftsbehandlingen och lämnar mitt samtycke till den. <a id="term02" ref="term02" class=" text-blue-1 underline cursor-pointer sm:w-auto">Här kan du läsa avtalet i sin helhet.</a>`;
    checkbox2.placeholder = checkbox2.label;
    checkbox2.isHtml = true;

    if (checkbox2?.validators)
      checkbox2.validators.push(aggrementApprovValidator);
    this.item.addMetadata(checkbox2);
    group.item.data.keys.push(checkbox2.key);

    this.item.addCheckboxGroup(group.item);
  }

  addTemplateCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("form_referer")) return;

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(
        property?.label || "Hur fick du veta att vi har utannonserad tjänst?",
        "group"
      ),
    };
    const profile = new Profile(new MainContainer(this.container));

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `form_referer`;

    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addCheckbox();
      checkbox.label = "Arbetsförmedlingens platsbank";
      checkbox.placeholder = "Arbetsförmedlingens platsbank";
      checkbox.key = crypto.randomUUID();
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);

      const secondCheckbox = this.addCheckbox();
      secondCheckbox.label = "Vår hemsida";
      secondCheckbox.placeholder = secondCheckbox.label;
      secondCheckbox.key = crypto.randomUUID();

      this.item.addMetadata(secondCheckbox);
      group.item.data.keys.push(secondCheckbox.key);

      const thirdCheckbox = this.addCheckbox();
      thirdCheckbox.label = "Sociala medier";
      thirdCheckbox.placeholder = "Sociala medier";
      thirdCheckbox.key = crypto.randomUUID();
      this.item.addMetadata(thirdCheckbox);
      group.item.data.keys.push(thirdCheckbox.key);

      const fourthCheckbox = this.addCheckbox();
      fourthCheckbox.label = "Tidningsannons";
      fourthCheckbox.placeholder = "Tidningsannons";
      fourthCheckbox.key = crypto.randomUUID();
      this.item.addMetadata(fourthCheckbox);
      group.item.data.keys.push(fourthCheckbox.key);

      const fifthCheckbox = this.addCheckbox();
      fifthCheckbox.label = "Tips från bekant";
      fifthCheckbox.placeholder = "Tips från bekant";
      fifthCheckbox.key = crypto.randomUUID();
      this.item.addMetadata(fifthCheckbox);
      group.item.data.keys.push(fifthCheckbox.key);
    }

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addSummerPositionChoicesCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("summerpositionchoicesform")) return;

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(
        property?.label || "Vilken/vilka tjänster är du intresserad av?",
        "group"
      ),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `summerpositionchoicesform`;
    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addCheckbox();
      checkbox.label = "";
      checkbox.placeholder = "";
      checkbox.key = crypto.randomUUID();
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);

      const secondCheckbox = this.addCheckbox();
      secondCheckbox.label = "";
      secondCheckbox.placeholder = "";
      secondCheckbox.key = crypto.randomUUID();
      this.item.addMetadata(secondCheckbox);
      group.item.data.keys.push(secondCheckbox.key);
    }
    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addSummerPositionPeriodsCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("summerpositionperiodsform")) return;

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(
        property?.label || "Vilken/vilka perioder kan du arbeta?",
        "group"
      ),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `summerpositionperiodsform`;

    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addCheckbox();
      checkbox.label = "Period 1";
      checkbox.placeholder = "t.ex. 1 maj - 30 juni";
      checkbox.key = crypto.randomUUID();
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);

      const secondCheckbox = this.addCheckbox();
      secondCheckbox.label = "Period 1";
      secondCheckbox.placeholder = "t.ex. 1 juli - 31 augusti";
      secondCheckbox.key = crypto.randomUUID();
      this.item.addMetadata(secondCheckbox);
      group.item.data.keys.push(secondCheckbox.key);
    }
    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addSummerPeriodsCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("summerperiodsform")) return;

    const group = {
      id: InputPeriodCheckboxGroup,
      item: this.createProperty(
        property?.label || "Vilka perioder kan du arbeta?",
        "periodGroup"
      ),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `summerperiodsform`;

    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addPeriodCheckbox();
      checkbox.label = "Period 1";
      checkbox.data = new dtos.PeriodProperty("", "", false);
      checkbox.key = crypto.randomUUID();
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);
    }

    this.item.addPeriodCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addLicenseToDriveCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("licensetodriveform")) return;

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(
        property?.label || "B-körkort och tillgång till egen bil",
        "group"
      ),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `licensetodriveform`;

    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addCheckbox();
      checkbox.label = "Jag har B-körkort";
      checkbox.placeholder = "Jag har B-körkort";
      checkbox.key = "licensetodrive_1";
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);

      const secondCheckbox = this.addCheckbox();
      secondCheckbox.label = "Jag har tillgång till egen bil";
      secondCheckbox.placeholder = "Jag har tillgång till egen bil";
      secondCheckbox.key = "licensetodrive_2";

      this.item.addMetadata(secondCheckbox);
      group.item.data.keys.push(secondCheckbox.key);
    }

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addDriverLicenseCheckboxGroup(
    property?: dtos.DynamicProperty,
    checkboxes?: dtos.DynamicProperty[]
  ) {
    if (this.checkIfPropertyIsAdded("driverlicenseform")) return;

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(
        property?.label ||
          "B-körkort (manuell och/eller automat) och tillgång till egen bil",
        "group"
      ),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `driverlicenseform`;

    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        const checkboxItem = this.addCheckbox();
        checkboxItem.label = checkbox?.label;
        checkboxItem.placeholder = checkbox?.placeholder;
        checkboxItem.key = checkbox?.key;
        this.item.addMetadata(checkboxItem);
        group.item.data.keys.push(checkboxItem.key);
      });
    } else {
      const checkbox = this.addCheckbox();
      checkbox.label = "Jag har B-körkort för manuell";
      checkbox.placeholder = "Jag har B-körkort för manuell";
      checkbox.key = "driverlicenseform_1";
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);

      const secondCheckbox = this.addCheckbox();
      secondCheckbox.label = "Jag har B-körkort för automat";
      secondCheckbox.placeholder = "Jag har B-körkort för automat";
      secondCheckbox.key = "driverlicenseform_3";
      this.item.addMetadata(secondCheckbox);
      group.item.data.keys.push(secondCheckbox.key);

      const thirdCheckbox = this.addCheckbox();
      thirdCheckbox.label = "Jag har tillgång till egen bil";
      thirdCheckbox.placeholder = "Jag har tillgång till egen bil";
      thirdCheckbox.key = "driverlicenseform_2";

      this.item.addMetadata(thirdCheckbox);
      group.item.data.keys.push(thirdCheckbox.key);
    }

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  private meritGroupCount = 0;
  addRequirementsCheckboxGroup() {
    if (this.checkIfPropertyIsAdded("requirementsform")) return;

    // Kontrollera att antalet meritgrupper inte överskrider 5
    if (this.meritGroupCount >= 4) {
      alert("Du kan inte skapa fler än 5 meritgrupper.");
      return;
    }

    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty("Meriterande för tjänsten", "group"),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;

    // Skapa den unika nyckeln baserat på antalet meritgrupper
    const uniqueKey = `requirementsform${crypto.randomUUID()}`;

    group.item.key = uniqueKey;

    const checkbox = this.addCheckbox();
    checkbox.label = "Merit 1";
    checkbox.placeholder = "Merit 1";

    // Använd samma unika nyckel för alla checkboxar inom gruppen
    checkbox.key = `${crypto.randomUUID()}`;

    this.item.addMetadata(checkbox);
    group.item.data.keys.push(checkbox.key);

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);

    // Öka räknaren för meritgrupper
    this.meritGroupCount++;
  }
  addCustomCheckboxGroupFromTemplate(
    properties: dtos.DynamicProperty[],
    label: string
  ) {
    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(label, "group"),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `customform_${this.someId++}`;

    properties.forEach((px) => {
      const checkbox = this.addCheckbox();
      checkbox.label = px?.label;
      checkbox.placeholder = px?.placeholder;
      checkbox.key = px?.key;
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);
    });

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addCustomCheckboxGroup() {
    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty("Checkboxgrupp", "group"),
    };

    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `customform_${this.someId++}`;

    const checkbox = this.addCheckbox();
    checkbox.label = "";
    checkbox.placeholder = "";
    this.item.addMetadata(checkbox);
    group.item.data.keys.push(checkbox.key);

    const secondCheckbox = this.addCheckbox();
    secondCheckbox.label = "";
    secondCheckbox.placeholder = "";
    this.item.addMetadata(secondCheckbox);
    group.item.data.keys.push(secondCheckbox.key);

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }
  addCheckboxGroup() {
    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty("Checkbox-grupp", "group"),
    };
    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `form_${this.someId++}`;

    const checkbox = this.addCheckbox();
    this.item.addMetadata(checkbox);
    group.item.data.keys.push(checkbox.key);

    const secondCheckbox = this.addCheckbox();
    this.item.addMetadata(secondCheckbox);
    group.item.data.keys.push(secondCheckbox.key);

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }

  addRadioGroup() {
    const group = {
      id: InputRadioGroup,
      item: this.createProperty("Min radiogrupp", "radioGroup"),
    };
    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `radio-group_${crypto.randomUUID()}`;

    const radioButton = this.addRadioButton();
    radioButton.label = "Radioknapp 1";
    radioButton.data = false;
    radioButton.key = crypto.randomUUID();
    this.item.addMetadata(radioButton);
    group.item.data.keys.push(radioButton.key);

    const secondRadioButton = this.addRadioButton();
    secondRadioButton.label = "Radioknapp 2";
    secondRadioButton.data = false;
    secondRadioButton.key = crypto.randomUUID();
    this.item.addMetadata(secondRadioButton);
    group.item.data.keys.push(secondRadioButton.key);

    this.item.addRadioGroup(group.item);
    this.item.addMetadata(group.item);

    return group.item;
  }
  addRadioGroupFromTemplate(properties: dtos.DynamicProperty[], label: string) {
    const group = {
      id: InputRadioGroup,
      item: this.createProperty(label, "radioGroup"),
    };
    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = label;
    group.item.key = `radio-group_${crypto.randomUUID()}`;

    properties.forEach((px) => {
      const radioButton = this.addRadioButton();
      radioButton.label = px?.label;
      radioButton.data = px?.data;
      radioButton.key = px?.key;
      this.item.addMetadata(radioButton);
      group.item.data.keys.push(radioButton.key);
    });

    this.item.addRadioGroup(group.item);
    this.item.addMetadata(group.item);

    return group.item;
  }
  addRequirementCheckboxGroupFromTemplate(
    properties: dtos.DynamicProperty[],
    label: string
  ) {
    const group = {
      id: InputCheckboxGroup,
      item: this.createProperty(label, "group"),
    };
    group.item.data = new dtos.DynamicPropertyGroupItem();
    group.item.data.label = group.item.placeholder;
    group.item.key = `requirementsform` + global.crypto.randomUUID();

    properties.forEach((dynamicProperty) => {
      const checkbox = this.addCheckbox();
      checkbox.label = dynamicProperty?.label;
      checkbox.key = `${
        dynamicProperty?.key.includes(group.item.key)
          ? dynamicProperty.key
          : group.item.key
      }_${dynamicProperty?.key}`;
      this.item.addMetadata(checkbox);
      group.item.data.keys.push(checkbox.key);
    });

    this.item.addCheckboxGroup(group.item);
    this.item.addMetadata(group.item);
  }

  createProperty(
    placeholder: string,
    type: string,
    label?: string,
    key?: string
  ): dtos.DynamicProperty {
    this.someId = this.someId + 1;
    const item = new dtos.DynamicProperty();
    item.placeholder = placeholder;
    item.type = type;
    item.key = key || "form_" + crypto.randomUUID();
    item.label = label || placeholder;
    item.order = this.someId;

    return item;
  }
  createFormKey(): string {
    return "form_" + crypto.randomUUID();
  }
  createInput(
    placeholder: string,
    type: string,
    key: string,
    label?: string
  ): dtos.PropertyItem {
    const item = {
      id: InputText,
      item: this.createProperty(placeholder, type),
    };
    item.item.label = label || placeholder;
    item.item.key = key;

    return new dtos.PropertyItem(item.item, item.id);
  }
  createTextInputWithHelpLink(
    placeholder: string,
    type: string,
    key: string,
    helpLink?: string
  ): dtos.PropertyItem {
    const item = {
      id: InputTextWithHelpLink,
      item: this.createProperty(placeholder, type),
    };
    item.item.label = placeholder;
    item.item.key = key;
    helpLink && (item.item.placeholder = helpLink);
    return new dtos.PropertyItem(item.item, item.id);
  }
  createInputTextarea(
    placeholder: string,
    key: string,
    label?: string
  ): dtos.PropertyItem {
    const item = {
      id: InputTextarea,
      item: this.createProperty(placeholder, "textarea"),
    };
    item.item.label = label || placeholder;
    item.item.key = key;
    return new dtos.PropertyItem(item.item, item.id);
  }
  createInputFile(
    placeholder: string,
    type: string,
    key: string
  ): dtos.PropertyItem {
    const item = {
      id: InputFile,
      item: this.createProperty(placeholder, type),
    };
    item.item.label = placeholder;
    item.item.key = key;
    return new dtos.PropertyItem(item.item, item.id);
  }
}

export class PositionFormTemplate extends FormTemplate {
  PositionTemplateAsset: PositionTemplateAsset;
  key = "";
  name = "";
  description = "";
  createdAt = 0;
  createdBy = {};
  availableInPositionTypes: {
    positionTypeId: number;
    positionTypeName: string;
    included: boolean;
    default: boolean;
  }[] = [];

  constructor(
    asset: PositionTemplateAsset,
    container: dtos.ContainerResponse,
    formbuilder: FormBuilder2,
    positionTypes: {
      id: number;
      name: string;
    }[]
  ) {
    super(container, formbuilder);
    this.PositionTemplateAsset = asset;
    this.key = crypto.randomUUID();
    this.name = "";
    this.description = "";
    this.createdAt = Date.now();
    this.createdBy = {} as ContainerUser;
    this.availableInPositionTypes = positionTypes.map((pt) => ({
      positionTypeId: pt.id,
      positionTypeName: pt.name,
      included: false,
      default: false,
    }));
  }
}
